import React, {useEffect, useState} from 'react';
import {getAnalytics, logEvent} from '@react-native-firebase/analytics';
import {Container, PanelImage} from './styles';
import {VehiclesModal} from '../VehiclesModal';

interface Props {
  data: {
    id: number;
    title?: string;
    imageUrl: any;
    texto: string;
    imageModal: any;
    steps?: {id: number; texto: string}[];
  };
  onOpenModal: () => void;
  onCloseModal: () => void;
}

export function BannerWithModal({data, onOpenModal, onCloseModal}: Props) {
  const [showModal, setShowModal] = useState(false);

  function handleOpenModal() {
    onOpenModal();
    setShowModal(true);
  }

  function handleDismissModal() {
    onCloseModal();
    setShowModal(false);
  }

  useEffect(() => {
    if (showModal) {
      const analytics = getAnalytics();
      logEvent(analytics, 'modal_tela_veiculos_' + data.id);
    }
  }, [showModal]);

  return (
    <Container onPress={handleOpenModal} activeOpacity={0.7}>
      <PanelImage source={data.imageUrl} resizeMode="cover" />
      <VehiclesModal
        onDismiss={handleDismissModal}
        data={data}
        showModal={showModal}
      />
    </Container>
  );
}
